const awsmobile = {
    "aws_user_pools_web_client_id": "m3mkl42tvmfvgh9fon63aggn0",
};


export default awsmobile;
